<template>
    <div>
        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%">
                <div slot="header" class="clearfix">
                    <span>账户明细</span>
                    <el-button style="float:right;" v-loading="saveLoading" type="primary" @click="save">保存</el-button>
                </div>
                <el-form ref="form" :model="profile" :rules="rules" label-width="150px">
                    <el-form-item label="账户名">
                        {{profile.account}}
                    </el-form-item>
                    <el-form-item label="名称" prop="name">
                        <el-input style="width: 300px" v-model="profile.name"></el-input>
                    </el-form-item>
                    <el-form-item label="最后登录时间">
                        {{profile.lastLoginTime | parseTime('{y}-{m}-{d} {h}:{i}')}}
                    </el-form-item>
                    <el-form-item label="角色">
                        {{profile.isSuper? '超级管理员': profile.roleName}}
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Profile',
    components: {},
    data() {
        return {
            saveLoading: false,
            profile: {
                account: "",
                name: ""
            },
            rules: {
                name: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 12,
                    message: '名称长度应在1-12位',
                    trigger: 'blur'
                }]
            }
        }
    },
    activated() {
        this.retrieveProfile()
        if (this.$refs['form']) {
            this.$refs['form'].resetFields();
        }
    },
    methods: {
        retrieveProfile() {
            var parent = this;
            this.$httpAuth
                .post("/v1/backendOperatorRpc/profile", {})
                .then(function (response) {
                    parent.profile = response.data.profile
                    console.log(parent.profile)
                })
        },
        save() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    var parent = this;
                    parent.saveLoading = true;
                    this.$httpAuth
                        .post("/v1/backendOperatorRpc/updateProfile", {
                            "name": this.profile.name,
                        })
                        .then(function (response) {
                            parent.saveLoading = false
                            parent.profile = response.data.profile
                            parent.retrieveProfile()

                            parent.$message({
                                message: '保存成功!',
                                type: 'success'
                            });
                        })
                        .catch(() => {
                            parent.saveLoading = false
                        });
                }
            });

        }
    }
}
</script>
